import React, { createContext, useContext, useEffect, useState } from "react";
import style from "./QRViewport.scss";
import { FormattedMessage } from "react-intl";
import { QrDownloadInput } from "../input/QrDownloadInput";
import classNames from "classnames";
import PropTypes from "prop-types";

const QrCodeContext = createContext();

export const useQrCode = () => {
  return useContext(QrCodeContext);
};

export const QrCodeContextProvider = ({ children }) => {
  const [qrCode, setQrCode] = useState(null);
  const [loading, setLoading] = useState(true);

    const getQRCode = async () => {
      try {
        // Your API call logic here
        const dashboardChannel = window.APP.dashboardChannel;
        const qrCode = await dashboardChannel.getQr();
        setQrCode(qrCode);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching QR code:", error);
        setLoading(false);
      }
    };

  useEffect(() => {
    window.addEventListener('refresh-qr-code', getQRCode);
    if (!qrCode) {
      getQRCode();
    }
    return () => {
      window.removeEventListener('refresh-qr-code', getQRCode);
    };
  }, [qrCode]);

  return <QrCodeContext.Provider value={{ qrCode, loading }}>{children}</QrCodeContext.Provider>;
};

QrCodeContextProvider.propTypes = {
  children: PropTypes.node
};

export function QRViewport({ isDesktop, inline, hasDescription }) {
  const { qrCode } = useQrCode();

  const classNameViewport = isDesktop ? style.qrViewportDesktop : style.qrViewportMobile;
  const classShow = inline ? style.inline : "";
  const classDescription = hasDescription ? style.hasDescription : "";

  return (
    <div>
      {qrCode && (
        <div className={classNames(classNameViewport, classShow, classDescription)}>
          <p>
            <FormattedMessage id="room-entry-modal.qr-code" defaultMessage="SCAN TO ACCESS THIS VERSE" />
          </p>
          <img src={qrCode}></img>
          {!hasDescription && (
            <QrDownloadInput
              qrCode={qrCode}
              label={<FormattedMessage id="invite-popover.qr-code" defaultMessage="QR Code" />}
              buttonPreset="accent5"
            />
          )}
        </div>
      )}
    </div>
  );
}

QRViewport.propTypes = {
  isDesktop: PropTypes.bool,
  inline: PropTypes.bool,
  hasDescription: PropTypes.bool
};
